export const SENTRY_KEY_PATH =
  "https://4e577433209645f48c88ed65a9af600c@sentry.io/1804607";
